export const WMS_PERMISSIONS = {
  dashboard: {
    access: 'wms.dashboard.access',
  },
  locations: {
    read: 'wms.locations.read',
    create: 'wms.locations.create',
    modify: 'wms.locations.modify',
    delete: 'wms.locations.delete',
  },
  inventory: {
    read: 'wms.inventory.read',
    create: 'wms.inventory.create',
    modify: 'wms.inventory.modify',
    delete: 'wms.inventory.delete',
    receive: 'wms.inventory.receive',
    transfer: 'wms.inventory.transfer',
    adjust: 'wms.inventory.adjust',
  },
  serials: {
    read: 'wms.serials.read',
    create: 'wms.serials.create',
    modify: 'wms.serials.modify',
    transfer: 'wms.serials.transfer',
  },
  workOrders: {
    read: 'wms.work_orders.read',
    create: 'wms.work_orders.create',
    modify: 'wms.work_orders.modify',
    delete: 'wms.work_orders.delete',
  },
  picking: {
    read: 'wms.picking.read',
    create: 'wms.picking.create',
    assign: 'wms.picking.assign',
    execute: 'wms.picking.execute',
    cancel: 'wms.picking.cancel',
    delete: 'wms.picking.delete',
  },
  shipping: {
    read: 'wms.shipping.read',
    create: 'wms.shipping.create',
    modify: 'wms.shipping.modify',
    delete: 'wms.shipping.delete',
    ship: 'wms.shipping.ship',
  },
  procurement: {
    read: 'wms.procurement.read',
    create: 'wms.procurement.create',
    modify: 'wms.procurement.modify',
    delete: 'wms.procurement.delete',
    receive: 'wms.procurement.receive',
    qc: 'wms.procurement.qc',
  },
  suppliers: {
    read: 'wms.suppliers.read',
    create: 'wms.suppliers.create',
    modify: 'wms.suppliers.modify',
    delete: 'wms.suppliers.delete',
  },
  skus: {
    read: 'wms.skus.read',
    create: 'wms.skus.create',
    modify: 'wms.skus.modify',
    delete: 'wms.skus.delete',
  },
} as const;

